var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    {
      staticClass: "stretch-grid has-search",
      class: { "no-footer": _vm.onlyIsRecruiter && !_vm.isApprovedInstructor }
    },
    [
      _c(
        "q-collapsible",
        {
          staticClass: "search-box",
          attrs: { "collapse-icon": "fa fa-angle-down" }
        },
        [
          _c("template", { staticClass: "search-box", slot: "header" }, [
            _c(
              "h5",
              { staticStyle: { padding: "12px 0px 12px 13px", width: "100%" } },
              [
                _c("q-icon", {
                  staticStyle: { padding: "0 5px 3px" },
                  attrs: { name: "fa fa-search", color: "primary" }
                }),
                _vm._v("Class Search\n      ")
              ],
              1
            )
          ]),
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "sl-row",
                  staticStyle: { padding: "0 30px 5px", margin: "0" },
                  attrs: { id: "classSearchTop" }
                },
                [
                  _c("div", { staticClass: "sl-row no-margin" }, [
                    _c(
                      "div",
                      { staticClass: "sl-col-4" },
                      [
                        _c("q-input", {
                          attrs: { "float-label": "Class ID", clearable: "" },
                          on: {
                            clear: function($event) {
                              _vm.search()
                            }
                          },
                          model: {
                            value: _vm.searchFields.CLASS_ID,
                            callback: function($$v) {
                              _vm.$set(_vm.searchFields, "CLASS_ID", $$v)
                            },
                            expression: "searchFields.CLASS_ID"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "sl-col-4" },
                      [
                        _c(
                          "q-field",
                          { attrs: { helper: _vm.currentInstructorLabel } },
                          [
                            _c(
                              "q-input",
                              {
                                attrs: {
                                  "float-label": "Instructor",
                                  "clear-value": null,
                                  clearable: ""
                                },
                                on: {
                                  clear: function($event) {
                                    _vm.onSelectInstructor()
                                  }
                                },
                                model: {
                                  value: _vm.instructorFilter,
                                  callback: function($$v) {
                                    _vm.instructorFilter = $$v
                                  },
                                  expression: "instructorFilter"
                                }
                              },
                              [
                                _c("q-autocomplete", {
                                  attrs: {
                                    debounce: 500,
                                    "float-label": "Instructor",
                                    "max-results": 10
                                  },
                                  on: {
                                    search: _vm.onInstructorAutocomplete,
                                    selected: _vm.onSelectInstructor
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "sl-col-4" },
                      [
                        _c("q-input", {
                          attrs: { "float-label": "Address 1" },
                          model: {
                            value: _vm.searchFields["~ADDRESS_1"],
                            callback: function($$v) {
                              _vm.$set(_vm.searchFields, "~ADDRESS_1", $$v)
                            },
                            expression: "searchFields['~ADDRESS_1']"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "sl-row no-margin" }, [
                    _c(
                      "div",
                      { staticClass: "sl-col-4" },
                      [
                        _c("q-datetime", {
                          attrs: {
                            clearable: "",
                            before: [{ icon: "calendar_today" }],
                            type: "date",
                            format: "MM/DD/YYYY",
                            "float-label": "Start Date",
                            popover: ""
                          },
                          on: {
                            clear: function($event) {
                              _vm.search()
                            }
                          },
                          model: {
                            value: _vm.searchFields["CLASS_START_DATE"],
                            callback: function($$v) {
                              _vm.$set(
                                _vm.searchFields,
                                "CLASS_START_DATE",
                                $$v
                              )
                            },
                            expression: "searchFields['CLASS_START_DATE']"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "sl-col-4" },
                      [
                        _c("q-datetime", {
                          attrs: {
                            clearable: "",
                            before: [{ icon: "calendar_today" }],
                            type: "date",
                            format: "MM/DD/YYYY",
                            "float-label": "End Date",
                            popover: ""
                          },
                          on: {
                            clear: function($event) {
                              _vm.search()
                            }
                          },
                          model: {
                            value: _vm.searchFields["CLASS_END_DATE"],
                            callback: function($$v) {
                              _vm.$set(_vm.searchFields, "CLASS_END_DATE", $$v)
                            },
                            expression: "searchFields['CLASS_END_DATE']"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "sl-col-4" },
                      [
                        _c("q-select", {
                          attrs: {
                            clearable: "",
                            "float-label": "Course",
                            options: _vm.courses
                          },
                          on: {
                            clear: function($event) {
                              _vm.search()
                            }
                          },
                          model: {
                            value: _vm.searchFields.COURSE_ID,
                            callback: function($$v) {
                              _vm.$set(_vm.searchFields, "COURSE_ID", $$v)
                            },
                            expression: "searchFields.COURSE_ID"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "sl-row no-margin" }, [
                    _c(
                      "div",
                      { staticClass: "sl-col-4" },
                      [
                        _c(
                          "q-field",
                          { attrs: { helper: _vm.currentAffiliateLabel } },
                          [
                            _c(
                              "q-input",
                              {
                                attrs: {
                                  "float-label": "Affiliate",
                                  "clear-value": null,
                                  clearable: ""
                                },
                                on: {
                                  clear: function($event) {
                                    _vm.onSelectAffiliate()
                                  }
                                },
                                model: {
                                  value: _vm.affiliateFilter,
                                  callback: function($$v) {
                                    _vm.affiliateFilter = $$v
                                  },
                                  expression: "affiliateFilter"
                                }
                              },
                              [
                                _c("q-autocomplete", {
                                  attrs: {
                                    debounce: 500,
                                    "float-label": "Affiliate",
                                    "max-results": 10
                                  },
                                  on: {
                                    search: _vm.onAffiliateAutocomplete,
                                    selected: _vm.onSelectAffiliate
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "sl-col-4" },
                      [
                        _c("q-select", {
                          attrs: {
                            clearable: "",
                            "float-label": "Class Status",
                            options: _vm.classStatuses
                          },
                          on: {
                            clear: function($event) {
                              _vm.search()
                            }
                          },
                          model: {
                            value: _vm.searchFields["LK_CLASS_STATUS_ID"],
                            callback: function($$v) {
                              _vm.$set(
                                _vm.searchFields,
                                "LK_CLASS_STATUS_ID",
                                $$v
                              )
                            },
                            expression: "searchFields['LK_CLASS_STATUS_ID']"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "sl-col-4",
                        staticStyle: { "padding-top": "20px" }
                      },
                      [
                        _c("q-checkbox", {
                          attrs: {
                            disable: !!_vm.searchFields["LK_CLASS_STATUS_ID"],
                            value: _vm.includeExpiredClasses,
                            label: "Include Expired Classes"
                          },
                          on: {
                            input: function(v) {
                              return _vm.setIncludeExpiredClasses(v)
                            }
                          }
                        }),
                        _c("q-checkbox", {
                          attrs: {
                            value: _vm.searchFields["INCLUDE_INACTIVE_AFF"],
                            label: "Include Inactive Affiliates"
                          },
                          on: {
                            input: function(v) {
                              return _vm.setIncludeInactiveAffiliates(v)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "sl-row no-margin" }, [
                    _c(
                      "div",
                      { staticClass: "sl-col-4" },
                      [
                        _c("q-select", {
                          attrs: {
                            clearable: "",
                            "float-label": "Payment Status",
                            options: _vm.orderStatuses
                          },
                          on: {
                            clear: function($event) {
                              _vm.search()
                            }
                          },
                          model: {
                            value: _vm.searchFields["PAYMENT_STATUS"],
                            callback: function($$v) {
                              _vm.$set(_vm.searchFields, "PAYMENT_STATUS", $$v)
                            },
                            expression: "searchFields['PAYMENT_STATUS']"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c(
                "q-toolbar",
                {
                  staticStyle: { "padding-right": "60px" },
                  attrs: { color: "white" }
                },
                [
                  _c("q-toolbar-title"),
                  _c("q-btn", {
                    staticStyle: { "margin-right": "5px" },
                    attrs: {
                      color: "secondary",
                      label: "Clear",
                      outline: "",
                      size: "sm",
                      type: "reset"
                    },
                    on: { click: _vm.resetAndSearch }
                  }),
                  _c("q-btn", {
                    attrs: {
                      color: "primary",
                      label: "Search",
                      size: "sm",
                      type: "submit"
                    },
                    on: {
                      click: function($event) {
                        _vm.search()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _c("Grid", {
        attrs: {
          id: "classListGrid",
          expandable: true,
          module: _vm.module,
          data: _vm.classList,
          columns: _vm.columns,
          pagination: _vm.pagination,
          onRequest: _vm.fetchClasses,
          onLaunch: _vm.select,
          onExport: _vm.fetchClasses,
          onExpand: _vm.expandClass,
          loading: _vm.loadingData,
          rowsPerPageOptions: [10, 20, 30, 50, 100]
        },
        scopedSlots: _vm._u([
          {
            key: "col-item-date_created",
            fn: function(props) {
              return [
                _vm.classList[props.index].UPLOADED_IND
                  ? _c("q-icon", {
                      attrs: { name: "cloud_upload", color: "green" }
                    })
                  : _vm._e(),
                _vm._v(
                  " " +
                    _vm._s(_vm.moment(props.value).format("MMMM DD, YYYY")) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "col-item-instructors",
            fn: function(props) {
              return [
                _vm._v("\n      " + _vm._s(props.value.length) + "\n      "),
                props.value.length > 0
                  ? _c("q-tooltip", [
                      _c(
                        "ul",
                        _vm._l(props.value, function(ins) {
                          return _c("li", { key: ins.INSTRUCTOR_ID }, [
                            _vm._v(
                              _vm._s(ins.FIRST_NAME) +
                                " " +
                                _vm._s(ins.LAST_NAME)
                            )
                          ])
                        })
                      )
                    ])
                  : _vm._e()
              ]
            }
          },
          {
            key: "col-item-class_start_date",
            fn: function(props) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm
                        .moment(props.value, "YYYY-MM-DD HH:mm")
                        .utc()
                        .format("MMMM Do, YYYY h:mm A")
                    ) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "col-item-class_end_date",
            fn: function(props) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm
                        .moment(props.value, "YYYY-MM-DD HH:mm")
                        .utc()
                        .format("MMMM Do, YYYY h:mm A")
                    ) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "col-item-students",
            fn: function(props) {
              return [_vm._v("\n      " + _vm._s(props.value) + "\n    ")]
            }
          },
          {
            key: "col-item-lk_class_status_id",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label",
                    class: {
                      blue: props.value == "SCHEDULED",
                      green:
                        props.value == "ACTIVE" ||
                        props.value == "APPROVED" ||
                        props.value == "COMPLETED",
                      purple: props.value == "PROCESSED",
                      red: props.value == "CANCELLED",
                      yellow: props.value == "HELD"
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [_vm._v("\n        " + _vm._s(props.value) + "\n      ")]
                )
              ]
            }
          },
          {
            key: "col-item-lk_class_approval_status_id",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label",
                    class: {
                      blue:
                        props.value == "SUBMITTED" ||
                        props.value == "RESUBMITTED",
                      green: props.value == "APPROVED",
                      red: props.value == "REJECTED",
                      yellow: props.value == "EXPIRED"
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [_vm._v("\n        " + _vm._s(props.value) + "\n      ")]
                )
              ]
            }
          },
          {
            key: "col-item-expand",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "relative-position",
                    staticStyle: { "min-height": "150px" }
                  },
                  [
                    _c(
                      "q-inner-loading",
                      {
                        attrs: {
                          visible: _vm.classList[props.props.key].loading
                        }
                      },
                      [
                        _c("q-spinner-puff", {
                          attrs: { color: "primary", size: "70" }
                        }),
                        _c("span", [_vm._v("Loading Sessions..")])
                      ],
                      1
                    ),
                    props.props.row.SESSIONS.length
                      ? _c(
                          "div",
                          { staticClass: "sessions-table" },
                          [
                            _c("div", { staticClass: "sl-row table-head" }, [
                              _c("div", { staticClass: "sl-col-9" }, [
                                _vm._v("\n              Sessions\n            ")
                              ])
                            ]),
                            _c("div", { staticClass: "sl-row table-columns" }, [
                              _c("div", { staticClass: "sl-col-1" }, [
                                _vm._v("\n              View\n            ")
                              ]),
                              _c("div", { staticClass: "sl-col-2" }, [
                                _vm._v(
                                  "\n              Start Date\n            "
                                )
                              ]),
                              _c("div", { staticClass: "sl-col-2" }, [
                                _vm._v("\n              End Date\n            ")
                              ]),
                              _c("div", { staticClass: "sl-col-1" }, [
                                _vm._v("\n              Students\n            ")
                              ]),
                              _c("div", { staticClass: "sl-col-1" }, [
                                _vm._v(
                                  "\n              Instructors\n            "
                                )
                              ]),
                              _c("div", { staticClass: "sl-col-2" }, [
                                _vm._v("\n              Location\n            ")
                              ])
                            ]),
                            _vm._l(props.props.row.SESSIONS, function(session) {
                              return _c(
                                "div",
                                {
                                  key: session.SESSION_ID,
                                  staticClass: "sl-row"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "sl-col-1 row-actions" },
                                    [
                                      _c(
                                        "q-btn",
                                        {
                                          attrs: {
                                            icon: "fa fa-external-link",
                                            outline: "",
                                            color: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.select(
                                                props.props.row,
                                                session.SESSION_ID
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "q-tooltip",
                                            {
                                              attrs: {
                                                anchor: "bottom middle",
                                                self: "top middle",
                                                offset: [10, 10]
                                              }
                                            },
                                            [_vm._v("View")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "sl-col-2" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm
                                            .moment(session.START_DATE)
                                            .format("MMMM Do, YYYY h:mm A")
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _c("div", { staticClass: "sl-col-2" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm
                                            .moment(session.END_DATE)
                                            .format("MMMM Do, YYYY h:mm A")
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _c("div", { staticClass: "sl-col-1" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(session.STUDENT_COUNT) +
                                        "\n            "
                                    )
                                  ]),
                                  _c("div", { staticClass: "sl-col-1" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(session.INSTRUCTOR_COUNT) +
                                        "\n            "
                                    )
                                  ]),
                                  _c("div", { staticClass: "sl-col-2" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(session.LOCATION) +
                                        "\n            "
                                    )
                                  ])
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      !_vm.onlyIsRecruiter && _vm.isApprovedInstructor
        ? _c(
            "q-layout-footer",
            [
              _c(
                "q-toolbar",
                [
                  _c("q-toolbar-title"),
                  _c("q-btn", {
                    attrs: {
                      label: "Upload",
                      icon: "cloud_upload",
                      color: "green",
                      outline: ""
                    },
                    on: {
                      click: function($event) {
                        _vm.scheduleUpload()
                      }
                    }
                  }),
                  _vm._v(" \n      "),
                  _c("q-btn", {
                    attrs: { label: "New", icon: "add", color: "primary" },
                    on: {
                      click: function($event) {
                        _vm.select({})
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }